import {useState} from 'react'
import AqcForm from './AqcForm';
import AqcListview from './AqcListview';

const AQC = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <AqcForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <AqcListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}
      </>
  )
}

export default AQC